<div class="error-item">
  <div class="error-details">
    <div class="error-location">
      <span class="num-text-accent font-weight-medium">
        {{ 'APPLAYOUT.HEADER.ERROR_LOG.MODAL.ITEM.LOCATION' | translate }}
      </span>
      <code>{{ error()?.getLocation() }}{{ profileUpgrade()?.getLocation() }}</code>
    </div>
    <div>
      <span class="num-text-accent font-weight-medium">
        {{ 'APPLAYOUT.HEADER.ERROR_LOG.MODAL.ITEM.CODE' | translate }}
      </span>
      <code>{{ error()?.getCode() }}{{ profileUpgrade()?.getCode() }}</code>
    </div>
    <div class="error-location">
      <span class="num-text-accent font-weight-medium">
        {{ 'APPLAYOUT.HEADER.ERROR_LOG.MODAL.ITEM.MESSAGE' | translate }}
      </span>
      <code>{{ error()?.getMessage() }} {{ profileUpgrade()?.getMessage() }}</code>
    </div>
    @if (error) {
    <div>
      <span class="num-text-accent font-weight-medium">
        {{ 'APPLAYOUT.HEADER.ERROR_LOG.MODAL.ITEM.DETAILS' | translate }}
      </span>
      <code>
        {{ 'VALIDATION.' + code | translate }}
      </code>
    </div>
    } @if (error()?.getCriteriaSetValidationIssue()) {
    <div class="error-extra">
      {{ 'APPLAYOUT.HEADER.ERROR_LOG.MODAL.ITEM.TERMCODE' | translate }}
      <code>{{ error()?.getCriteriaSetValidationIssue()?.getCriteriaSet() | json }}</code>
    </div>
    } @if (error()?.getValueSetValidationIssue()) {
    <div class="error-extra">
      {{ 'APPLAYOUT.HEADER.ERROR_LOG.MODAL.ITEM.VALUE_SETS' | translate }}
      <code>{{ error()?.getValueSetValidationIssue()?.getValueSets() | json }}</code>
    </div>
    } @if (error()?.getTimeRestrictionValidationIssue()) {
    <div class="error-extra">
      {{ 'APPLAYOUT.HEADER.ERROR_LOG.MODAL.ITEM.AFTER_DATE' | translate }}
      <code>{{ error()?.getTimeRestrictionValidationIssue()?.getAfterDate() | json }}</code>
      <br />
      {{ 'APPLAYOUT.HEADER.ERROR_LOG.MODAL.ITEM.BEFORE_DATE' | translate }}
      <code>{{ error()?.getTimeRestrictionValidationIssue()?.getBeforeDate() | json }}</code>
    </div>
    } @if (error()?.getQuantityUnitValidationIssue()) {
    <div class="error-extra">
      <div>
        {{ 'APPLAYOUT.HEADER.ERROR_LOG.MODAL.ITEM.SELECTED' | translate }}
        <code>{{ error()?.getQuantityUnitValidationIssue()?.getSelected() }}</code>
      </div>
      <div>
        {{ 'APPLAYOUT.HEADER.ERROR_LOG.MODAL.ITEM.ALLOWED' | translate }}
        <code>{{ error()?.getQuantityUnitValidationIssue()?.getAllowed() | json }}</code>
      </div>
    </div>
    } @if (error()?.getDataExtractionValidationIssue()) {
    <div class="error-extra">
      <div>
        {{ 'APPLAYOUT.HEADER.ERROR_LOG.MODAL.ITEM.BEFORE_DATE' | translate }}
        <code>{{ error()?.getDataExtractionValidationIssue()?.getStart() }}</code>
      </div>
      <div>
        {{ 'APPLAYOUT.HEADER.ERROR_LOG.MODAL.ITEM.AFTER_DATE' | translate }}
        <code>{{ error()?.getDataExtractionValidationIssue()?.getEnd() }}</code>
      </div>
    </div>
    } @if (error()?.getQuantityRangeValidationIssue()) {
    <div class="error-extra">
      <div>
        {{ 'APPLAYOUT.HEADER.ERROR_LOG.MODAL.ITEM.MIN_VALUE' | translate }}
        <code>{{ error()?.getQuantityRangeValidationIssue()?.getMinValue() }}</code>
      </div>
      <div>
        {{ 'APPLAYOUT.HEADER.ERROR_LOG.MODAL.ITEM.MAX_VALUE' | translate }}
        <code>{{ error()?.getQuantityRangeValidationIssue()?.getMaxValue() }}</code>
      </div>
    </div>
    }

    <!-- Profile Upgrade Details -->
    @if (profileUpgrade()?.getProfileRemoved()) {
    <div>
      <span class="num-text-accent font-weight-medium">
        {{ 'APPLAYOUT.HEADER.ERROR_LOG.MODAL.ITEM.DETAILS' | translate }}
      </span>
      <span
        [innerHTML]="
          'APPLAYOUT.HEADER.UPGRADE_LOG.MODAL.ITEM.REMOVED_PROFILE'
            | translate : { profileName: profileUpgrade()?.getProfileRemoved()?.getName() }
        "
      >
      </span>
    </div>
    } @if (profileUpgrade()?.getProfileFieldChange(); as change) {
    <div>
      <span class="num-text-accent font-weight-medium">
        {{ 'APPLAYOUT.HEADER.ERROR_LOG.MODAL.ITEM.DETAILS' | translate }}
      </span>
      <span
        [innerHTML]="
          'APPLAYOUT.HEADER.UPGRADE_LOG.MODAL.ITEM.UPGRADE_FIELDS'
            | translate
              : {
                  replaced: change.getReplaced(),
                  replacedWith: change.getReplacedWith()
                }
        "
      >
      </span>
    </div>
    } @if (profileUpgrade()?.getProfileFieldRemoved()) {
    <div>
      <span class="num-text-accent font-weight-medium">
        {{ 'APPLAYOUT.HEADER.ERROR_LOG.MODAL.ITEM.DETAILS' | translate }}
      </span>
      <span
        [innerHTML]="
          'APPLAYOUT.HEADER.UPGRADE_LOG.MODAL.ITEM.REMOVED_FIELDS'
            | translate
              : {
                  replaced: profileUpgrade()?.getProfileFieldRemoved()?.getReplaced()
                }
        "
      >
      </span>
    </div>
    } @if (profileUpgrade()?.getProfileFilterChange()) {
    <div>
      <span class="num-text-accent font-weight-medium">
        {{ 'APPLAYOUT.HEADER.ERROR_LOG.MODAL.ITEM.DETAILS' | translate }}
      </span>
      <span>
        {{ 'APPLAYOUT.HEADER.UPGRADE_LOG.MODAL.ITEM.UPGRADE_FILTER' | translate }}
      </span>
    </div>
    }
  </div>
</div>
